// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"loudspeaker"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M9 7H3V12.5H9L15 15V4L9 7Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M3 21V12.5H7L6 21H3Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 12.5V7H9L15 4V15L9 12.5H3ZM3 12.5V21H6L7 12.5H3ZM6.85 16H8.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M18.25 8.66895C18.9403 9.35927 18.9403 10.4785 18.25 11.1688M20.3335 7C21.7142 8.38066 21.7142 11.453 20.3335 12.8336","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const LoudspeakerIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'loudspeaker',
    ref,
    icon: element,
  },
));

LoudspeakerIcon.displayName = 'LoudspeakerIcon';

export default LoudspeakerIcon;
